import { AUTH_ENDPOINTS } from '../constants/apiEndpoints';
import { apiClient } from './apiClient';

interface IIntroStatusResponse {
	success?: boolean;
	status?: string;
	message?: string;
	data?: {
		completed?: boolean;
		completed_at?: string | null;
	};
}

export const introService = {
	async getStatus(): Promise<boolean> {
		const response = await apiClient<IIntroStatusResponse>(AUTH_ENDPOINTS.INTRO_STATUS, {
			method: AUTH_ENDPOINTS.INTRO_STATUS.method,
			requiresAuth: true,
		});
		return Boolean(response?.data?.completed);
	},

	async complete(): Promise<void> {
		await apiClient(AUTH_ENDPOINTS.INTRO_COMPLETE, {
			method: AUTH_ENDPOINTS.INTRO_COMPLETE.method,
			body: {},
			requiresAuth: true,
		});
	},
};

export default introService;